import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getAllBlogPosts, getBlogPostBySlug } from '../content/blogPosts';
import Navbar from '../components/Navbar';
import { getDownloadUrl } from '../storeLinks';

function BlogPost() {
  const { t } = useTranslation();
  const { slug } = useParams();
  const navLinks = [
    { label: t('nav.journal'), to: '/blog' },
    { label: t('nav.pricing'), to: '/pricing' },
    { label: t('nav.download'), to: getDownloadUrl(), external: true, cta: true },
  ];
  const post = getBlogPostBySlug(slug);
  const otherPosts = getAllBlogPosts().filter((entry) => entry.slug !== slug);

  if (!post) {
    return (
      <div className="blog-page">
        <div className="container blog-not-found">
          <Link to="/blog" className="back-link">{t('blog.backToJournal')}</Link>
          <h1>{t('blog.notFoundTitle')}</h1>
          <p>{t('blog.notFoundBody')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-page">
      <Navbar links={navLinks} />

      <article className="blog-article">
        <div className="container">
          <Link to="/blog" className="back-link">{t('blog.backToJournal')}</Link>
          <p className="blog-article-meta">
            <span>{post.date}</span>
            <span>{post.readTime}</span>
          </p>
          <h1>{post.title}</h1>
          <p className="blog-hero-copy">{post.hero}</p>

          <div className="blog-article-body">
            {post.sections.map((section) => (
              <section key={section.heading} className="blog-article-section">
                <h2>{section.heading}</h2>
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </section>
            ))}
          </div>
        </div>
      </article>

      {otherPosts.length > 0 && (
        <section className="blog-more">
          <div className="container">
            <h2>{t('blog.moreFrom')}</h2>
            <div className="blog-grid">
              {otherPosts.map((entry) => (
                <article key={entry.slug} className="blog-card">
                  <p className="blog-card-meta">
                    <span>{entry.date}</span>
                    <span>{entry.readTime}</span>
                  </p>
                  <h3>{entry.title}</h3>
                  <p>{entry.excerpt}</p>
                  <Link to={`/blog/${entry.slug}`} className="blog-card-link">
                    {t('blog.readEssay')}
                  </Link>
                </article>
              ))}
            </div>
          </div>
        </section>
      )}

      <footer>
        <div className="container">
          <div className="footer-brand">
            <img src="/logo192.png" alt={t('landing.hero.logoAlt')} className="footer-logo" />
            <span>10 Thirty</span>
          </div>
          <p>
            {t('landing.footer.copyright', { year: new Date().getFullYear() })}{' '}
            {t('landing.footer.broughtToYou')}{' '}
            <a href="https://www.callitservices.co.za" target="_blank" rel="noopener noreferrer">{t('landing.footer.callItServices')}</a>
          </p>
          <div className="links">
            <Link to="/">{t('landing.footer.linkHome')}</Link>
            <Link to="/blog">{t('landing.footer.linkJournal')}</Link>
            <Link to="/privacy">{t('landing.footer.linkPrivacy')}</Link>
            <Link to="/terms">{t('landing.footer.linkTerms')}</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default BlogPost;
